// import request from "@/utils/request"



// function getLogin(formData) {
//     return request({
//         method: "POST",
//         // https://apply.hnzyxsbh.comapply/index/login
//         url: "apply/index/login",
//         headers:{
//             "Content-Type": "multipart/form-data"
//         },
//         data: formData
//       })
// }


// export { getLogin }
import request from "@/utils/request"



// 登录
export const login = (user) => {

    return request({
      method: "POST",
      data:user,
      url: "/handle/index/login",
    });
  };

  export const logins = (user) => {

    return request({
      method: "POST",
      data:user,
      url: "/handle/index/renzheng_geren",
    });
  };
  export const getrenzheng = (user) => {

    return request({
      method: "POST",
      data:user,
      url: "/handle/company/getrenzheng",
    });
  };
  
  export const frzrenzheng = (user) => {

    return request({
      method: "POST",
      data:user,
      url: "/handle/company/frzrenzheng",
    });
  };
  
  export const gzrenzheng = (user) => {

    return request({
      method: "POST",
      data:user,
      url: "/handle/company/gzrenzheng",
    });
  };
  export const sf_order = (user) => {

    return request({
      method: "POST",
      data:user,
      url: "/handle/kuaidi/sf_order",
    });
  };
  export const addresslist = (user) => {

    return request({
      method: "POST",
      data:user,
      url: "/handle/address/addresslist",
    });
  };
  export const addresslists = (user) => {

    return request({
      method: "POST",
      data:user,
      url: "/handle/baohan/bhfiles_create",
    });
  };


  



// WEBPACK FOOTER //
// ./src/api/user.js